var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (['MoreSettingsLayout', 'AppLayout', 'ChatLayout'].includes(this.$route.meta.layout))?_c('AppComponent',[_c(_vm.layout,{tag:"component"})],1):_c(_vm.layout,{tag:"component"})}
var staticRenderFns = []

export { render, staticRenderFns }